import { render, staticRenderFns } from "./InStoreSettings.template.vue?vue&type=template&id=af03edf4&scoped=true&"
var script = {}
import style0 from "./InStoreSettings.template.vue?vue&type=style&index=0&id=af03edf4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af03edf4",
  null
  
)

export default component.exports